import React from 'react';
// Zustand
import { useStore } from '../../zustand';
// Components
import Backdrop from '@material-ui/core/Backdrop';
// Icons
import CircularProgress from '@material-ui/core/CircularProgress';
// Styles
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    text_loading: {
        color: '#fff',
        paddingTop: '1em'
    }
}));

export default function TempLoadingScreen() {
    const classes = useStyles();
    const { full_screen_loading } = useStore(state => state.twoD_settings);
    // const full_screen_loading = true

    if(!full_screen_loading) return

    return (
        <div>
            <Backdrop className={classes.backdrop} open={full_screen_loading}>
                <div className={classes.container}>
                    <CircularProgress color="inherit" />
                    <span className={classes.text_loading}>Loading</span>
                </div>
            </Backdrop>
        </div>
    );
}

